module.exports = __webpack_public_path__ + "img/灰色叉子1.06782bb4.png";